module.exports = __webpack_public_path__ + "static/media/banner_small.4d631c83.jpg";